import { IProjectCollateralCategory } from '~/@api/generated-api-types-project/Api'
import type { ObjectValues } from '~/@lib/utils/type.utils'
import { getProjectCollateralCategoryLabel } from '../_projects_ui/project-collateral/labelByCollateralCategory'

export const ProjectCollateralCategory = {
  Residential: IProjectCollateralCategory.Residential,
  Commercial: IProjectCollateralCategory.Commercial,
  Land: IProjectCollateralCategory.Land,
  Recreational: IProjectCollateralCategory.Recreational,
  Other: IProjectCollateralCategory.Other,
} as const

export type ProjectCollateralCategory = ObjectValues<
  typeof ProjectCollateralCategory
>

export const ProjectCollateralCategoryArray = (function () {
  return Object.values(ProjectCollateralCategory).map((value) => {
    return {
      value,
      text: getProjectCollateralCategoryLabel(value),
    }
  })
})()
